var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 20.5C9.125 20.5 8 20.5 8 19.375C8 18.25 9.125 14.875 14.75 14.875C20.375 14.875 21.5 18.25 21.5 19.375C21.5 20.5 20.375 20.5 20.375 20.5H9.125ZM14.75 13.75C15.6451 13.75 16.5036 13.3944 17.1365 12.7615C17.7694 12.1286 18.125 11.2701 18.125 10.375C18.125 9.47989 17.7694 8.62145 17.1365 7.98851C16.5036 7.35558 15.6451 7 14.75 7C13.8549 7 12.9964 7.35558 12.3635 7.98851C11.7306 8.62145 11.375 9.47989 11.375 10.375C11.375 11.2701 11.7306 12.1286 12.3635 12.7615C12.9964 13.3944 13.8549 13.75 14.75 13.75Z",
    fill: "#C7C7C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 26,
    rx: 2.5,
    stroke: "#C7C7C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.4220ed71.svg";
export { ForwardRef as ReactComponent };